import Component from '@glimmer/component'
import { tracked } from '@glimmer/tracking'
import { action } from '@ember/object'
import { modifier } from 'ember-modifier'
import { on } from '@ember/modifier'
import Icon from 'customer-flows/components/ui-kit/icon'

export interface ReviewCommentSignature {
  Element: HTMLDivElement
  Args: {
    text?: string
  }
}

export default class ReviewComment extends Component<ReviewCommentSignature> {
  @tracked isClamped = false
  @tracked isExpanded = false

  checkIfClamped = modifier((element: HTMLElement) => {
    requestAnimationFrame(() => {
      if (element.scrollHeight > element.clientHeight) {
        this.isClamped = true
      }
    })
  })

  @action
  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded
  }

  <template>
    <div class='relative' data-testid='review-comment' ...attributes>
      <p
        class='text-reg-para-14 text-neutrals-300 {{if this.isClamped "pr-6"}} {{unless this.isExpanded "line-clamp-3"}}'
        {{this.checkIfClamped}}
        data-testid='review-comment__text'
      >
        {{@text}}
      </p>

      {{#if this.isClamped}}
        <button
          type='button'
          class='absolute right-0 bottom-0 flex items-center border-none bg-transparent p-0'
          data-testid='review-comment__toggle'
          {{on 'click' this.toggleExpansion}}
        >
          <Icon @src={{if this.isExpanded 'carat-up' 'carat-down'}} />
        </button>
      {{/if}}
    </div>
  </template>
}
